export default function Hero({ onApply }) {
  return (
    <section className="min-h-0 h-auto sm:min-h-screen sm:h-screen sm:max-h-[100dvh] flex flex-col justify-start sm:justify-center items-center sm:items-stretch px-5 pt-[72px] pb-4 sm:pb-8 sm:px-[5vw] relative overflow-hidden border-b border-border">
      {/* Grid Background */}
      <div className="hero-grid" />

      {/* Glow (center) */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[660px] h-[400px] pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse, rgba(255,82,16,0.12) 0%, transparent 70%)',
        }}
      />



      {/* Right: gradient + one circle + two lines; on xl stronger so it fills the space */}
      <div className="absolute inset-0 left-[45%] pointer-events-none hidden md:block" aria-hidden>
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(120deg, transparent 0%, rgba(255,82,16,0.04) 50%, rgba(255,82,16,0.08) 100%)',
          }}
        />
        <div className="absolute top-1/2 right-[15%] w-[260px] h-[260px] xl:w-[320px] xl:h-[320px] -translate-y-1/2 translate-x-1/2 rounded-full border border-orange/[0.08] xl:border-orange/[0.12]" />
        <div
          className="absolute top-[38%] right-0 w-[100%] h-px bg-gradient-to-l from-orange/12 to-transparent"
          style={{ transform: 'rotate(-6deg)', transformOrigin: 'right center' }}
        />
        <div
          className="absolute top-[58%] right-0 w-[90%] h-px bg-gradient-to-l from-orange/8 to-transparent"
          style={{ transform: 'rotate(4deg)', transformOrigin: 'right center' }}
        />
      </div>





      {/* Main content: on xl/2xl cap width so large screens don't look stretched; on mobile center everything */}
      <div className="w-full xl:max-w-[680px] 2xl:max-w-[720px] flex flex-col items-center sm:items-start">
      {/* Tag — loveable pill: soft glow, breathing dot, premium feel */}
      <div
        className="group inline-flex items-center gap-3 rounded-full border border-orange/30 bg-gradient-to-r from-orange/20 via-orange/12 to-transparent px-5 py-2.5 font-mono text-[11px] font-medium tracking-[0.22em] uppercase text-orange/95 mb-4 animate-fadeUp w-fit backdrop-blur-md transition-all duration-300 hover:border-orange/50 hover:from-orange/25 hover:via-orange/15 hover:shadow-[0_0_28px_-6px_rgba(255,82,16,0.25)] sm:hover:-translate-y-0.5"
        style={{
          boxShadow: '0 0 0 1px rgba(255,255,255,0.03) inset, 0 0 24px -8px rgba(255,82,16,0.15)',
        }}
      >
        <span className="relative flex h-2.5 w-2.5 shrink-0" aria-hidden>
          <span className="absolute inset-0 rounded-full bg-orange/90 shadow-[0_0_10px_2px_rgba(255,82,16,0.5)] animate-pulse" />
          <span className="absolute inset-0 rounded-full bg-orange blur-md opacity-60 animate-pulse" style={{ animationDuration: '2s' }} />
        </span>
        <span className="tracking-wide">Now Hiring <span className="text-orange/70">·</span> Dubai Media City</span>
      </div>

      {/* Title — slightly smaller on very small screens to avoid overlap */}
      <h1 className="font-bebas text-[clamp(36px,8.5vw,120px)] leading-[0.9] tracking-[0.02em] uppercase animate-[fadeUp_0.65s_0.08s_ease_both] max-w-[85vw] sm:max-w-none text-center sm:text-left">
        Creative
        <br />
        <span className="text-orange">Internship</span>
        <br />
        Program
      </h1>



      {/* Meta row: strip + right filler; on mobile both centered */}
      <div className="mt-4 sm:mt-5 flex flex-col sm:flex-row sm:flex-wrap items-center justify-center sm:justify-between gap-3 sm:gap-4 animate-[fadeUp_0.65s_0.18s_ease_both] w-full">
        <div className="inline-flex flex-wrap items-center justify-center sm:justify-start gap-x-4 gap-y-2 sm:gap-x-6 rounded-r border border-white/[0.06] border-l-[3px] border-l-orange/70 bg-white/[0.03] pl-3 pr-4 sm:pl-4 sm:pr-5 py-2.5 sm:py-3 font-mono text-[11px] sm:text-[12px] tracking-[0.08em] w-fit mx-auto sm:mx-0">
          {['Scalify Dubai', '3–6 Months', 'Copywriter | Designer', 'Stipend + Certificate'].map(
            (text, i) => (
              <span key={i} className="flex items-center gap-2 sm:gap-2.5 text-[#d8d5ce] transition-colors hover:text-[#f0ede6]">
                <span className="w-1.5 h-1.5 rounded-full bg-orange flex-shrink-0" aria-hidden />
                <span className="font-medium">{text}</span>
              </span>
            )
          )}
        </div>
      </div>
      </div>

      {/* Scroll hint — compact; on mobile move in so it doesn't overlap */}
      <div
        className="scroll-hint absolute bottom-4 right-3 sm:right-[5vw] font-mono text-[8px] text-muted/80 tracking-[0.2em] flex items-center gap-2"
        style={{ writingMode: 'vertical-rl' }}
      >
        SCROLL
        <span className="block w-px h-6 sm:h-8 bg-gradient-to-b from-orange/60 to-transparent" />
      </div>
    </section>
  );
}
